import Vuex from 'vuex'
import Vue from 'vue'

Vue.use(Vuex)

const serviceProviderStore = new Vuex.Store({
  state: {
    id: null,
    authMethods: ['standard'],
    oktaDomain: null,
    oktaClientId: null,
    oktaIssuer: null,
    slug: null,
  },
  mutations: {
    setAuthMethods(state, methods) {
      state.authMethods = methods
    },
    setSlug(state, slug) {
      state.slug = slug
    },
    setOktaDomain(state, oktaDomain) {
      state.oktaDomain = oktaDomain
    },
    setOktaClientId(state, oktaClientId) {
      state.oktaClientId = oktaClientId
    },
    setOktaIssuer(state, oktaIssuer) {
      state.oktaIssuer = oktaIssuer
    },
    setId(state, id) {
      state.id = id
    },
  },
  getters: {
    authMethods: function (state) {
      return state.authMethods
    },
    slug: function (state) {
      return state.slug
    },
    oktaDomain: function (state) {
      return state.oktaDomain
    },
    oktaClientId: function (state) {
      return state.oktaClientId
    },
    oktaIssuer: function (state) {
      return state.oktaIssuer
    },
    id: function (state) {
      return state.id
    },
  },
})

export default serviceProviderStore
